import React, { useEffect, useReducer, useRef } from "react";

function reducer(state, action) {
    switch (action.type) {
        case "collapse":
            return {
                collapse: !state.collapse
            };
        case "show":
            return {
                collapse: true
            };
    }
}

export function Accordion({
    index,
    isActive,
    toggleAccordion,
    question = "",
    count = "",
    show = false,
    answer
}) {
    const accordionBodyRef = useRef(null);
    const [{ collapse }, dispatch] = useReducer(reducer, {
        collapse: show
    });

    const randomId = useRef(
        window.crypto.getRandomValues(new Uint32Array(1))[0].toString(36)
    );

    useEffect(() => {
        if (show) dispatch({ type: "show" });
    }, [show]);

    return (
        <div className="accordion-item relative !bg-white/[0.03] !rounded-2xl !border-[1.5px] !border-white/[0.10] !backdrop-blur-[10px] !p-4 md:!py-[27px] md:!pl-10 !pr-0 overflow-hidden">
            <h3 className={`accordion-header !pr-[65px] md:!pr-28 ${isActive ? "" : " collapsed"}`}
                id={`heading-${randomId.current}`} aria-expanded={isActive}
                aria-controls={`collapse-${randomId.current}`}
                onClick={() => toggleAccordion(index)}
            >
                <button
                    className="!text-sm/5 md:!text-[24px]/6 !font-semibold !text-dim !-tracking-[0.96px] text-left flex gap-4 md:gap-6 !rounded-none !p-0 w-full"
                    type="button"
                >
                    <span className="pt-[2px]">{count}</span>
                    {question}
                </button>
            </h3>

            <div
                id={`collapse-${randomId.current}`}
                aria-labelledby={`heading-${randomId.current}`}
                className={`accordion-collapse`}
                style={
                    isActive
                        ? {
                            height: accordionBodyRef.current?.clientHeight,
                            transition: "height 0.2s ease",
                            overflow: "hidden"
                        }
                        : {
                            height: 0,
                            transition: "height 0.2s ease",
                            overflow: "hidden"
                        }
                }
            >
                <div className="accordion-body text-left !pt-4 md:!pt-[35px] !pb-0 !px-8 md:!pl-[47px] md:!pr-[70px] text-xsm md:text-sm/6 -tracking-[0.8px] text-dim opacity-[0.84]" ref={accordionBodyRef}>
                    {typeof answer === "string" ? (
                        <div dangerouslySetInnerHTML={{ __html: answer }} />
                    ) : (
                        answer
                    )}
                </div>
            </div>
        </div>
    );
}